import React from 'react';

export const ButtonArrow = ({ className = '', strokeWidth = '' }) => (
  <svg
    className={className}
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke="currentColor"
      strokeWidth={strokeWidth}
      d="M0.834043 6.00643C0.83603 6.13357 0.888379 6.25473 0.9796 6.34332C1.07082 6.4319 1.19346 6.48067 1.32061 6.47893L15.4815 6.47893L11.1072 10.8927C11.0628 10.9375 11.0277 10.9906 11.0038 11.049C10.98 11.1074 10.9678 11.1699 10.9681 11.233C10.9684 11.296 10.9812 11.3584 11.0056 11.4166C11.03 11.4747 11.0656 11.5275 11.1104 11.5719C11.1553 11.6163 11.2084 11.6514 11.2668 11.6753C11.3252 11.6991 11.3877 11.7112 11.4507 11.7109C11.5138 11.7106 11.5762 11.6979 11.6344 11.6735C11.6925 11.6491 11.7453 11.6134 11.7897 11.5686L16.974 6.33643C17.0629 6.24657 17.1127 6.1253 17.1127 5.99893C17.1127 5.87257 17.0629 5.7513 16.974 5.66143L11.7897 0.429245C11.7453 0.384431 11.6925 0.348798 11.6344 0.324381C11.5762 0.299963 11.5138 0.287239 11.4507 0.286934C11.3877 0.286629 11.3252 0.298749 11.2668 0.322605C11.2084 0.34646 11.1553 0.381582 11.1104 0.425964C11.0656 0.470347 11.03 0.523122 11.0056 0.581276C10.9812 0.63943 10.9684 0.701823 10.9681 0.764894C10.9678 0.827965 10.98 0.890479 11.0038 0.948865C11.0277 1.00725 11.0628 1.06037 11.1072 1.10518L15.4815 5.51893L1.32061 5.51893C1.25639 5.51805 1.19264 5.53007 1.13315 5.55427C1.07366 5.57847 1.01963 5.61436 0.97426 5.65982C0.92889 5.70528 0.893103 5.75938 0.869018 5.81891C0.844933 5.87845 0.83304 5.94222 0.834043 6.00643Z"
      fill="currentColor"
    />
  </svg>
);
